import { useState, useEffect } from "react";
import { BRAND } from "../constants/brand";

export default function PageHero({ eyebrow, title, highlight, subtitle }) {
  const [v, setV] = useState(false);
  useEffect(() => { const t = setTimeout(() => setV(true), 80); return () => clearTimeout(t); }, [title]);

  return (
    <section style={{
      background: `linear-gradient(160deg, ${BRAND.navyDeep} 0%, ${BRAND.navyDark} 50%, ${BRAND.navyMid} 100%)`,
      paddingTop: 76,
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Ambient blobs */}
      <div style={{
        position: "absolute", top: -80, right: -80, width: 420, height: 420,
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(201,169,110,0.12) 0%, transparent 70%)",
        animation: "drift1 18s ease-in-out infinite",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: -40, left: -40, width: 300, height: 300,
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(10,74,158,0.3) 0%, transparent 70%)",
        animation: "drift2 22s ease-in-out infinite",
        pointerEvents: "none",
      }} />

      {/* Grid pattern */}
      <div style={{ position: "absolute", inset: 0, opacity: 0.035, pointerEvents: "none" }}>
        <svg width="100%" height="100%">
          <defs>
            <pattern id="pg-grid" width="48" height="48" patternUnits="userSpaceOnUse">
              <path d="M 48 0 L 0 0 0 48" fill="none" stroke="white" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#pg-grid)"/>
        </svg>
      </div>

      {/* Left accent bar */}
      <div style={{
        position: "absolute", left: 0, top: 0, width: 3, height: "100%",
        background: `linear-gradient(180deg, transparent, ${BRAND.gold}, transparent)`,
      }} />

      <div className="rx-pad" style={{
        maxWidth: 1400, margin: "0 auto",
        padding: "80px 40px 72px",
        position: "relative", zIndex: 1,
      }}>
        {/* Eyebrow */}
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 20,
          opacity: v ? 1 : 0, transform: v ? "none" : "translateY(16px)",
          transition: "all 0.6s cubic-bezier(.4,0,.2,1)",
        }}>
          <div style={{ width: 28, height: 1, background: BRAND.gold }} />
          <span style={{
            fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600,
            letterSpacing: "0.25em", color: BRAND.gold, textTransform: "uppercase",
          }}>{eyebrow}</span>
          <div style={{ width: 28, height: 1, background: BRAND.gold }} />
        </div>

        {/* Title */}
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 700,
          fontSize: "clamp(34px, 5vw, 58px)",
          lineHeight: 1.1,
          color: BRAND.white,
          margin: "0 0 18px",
          opacity: v ? 1 : 0,
          transform: v ? "none" : "translateY(24px)",
          transition: "all 0.75s cubic-bezier(.4,0,.2,1) 0.1s",
        }}>
          {title}{highlight && <> <span style={{ color: BRAND.gold }}>{highlight}</span></>}
        </h1>

        {/* Subtitle */}
        {subtitle && (
          <p style={{
            fontFamily: "'Inter', sans-serif", fontSize: 16,
            color: "rgba(255,255,255,0.6)", lineHeight: 1.75,
            maxWidth: 600, margin: 0,
            fontWeight: 400,
            opacity: v ? 1 : 0,
            transform: v ? "none" : "translateY(16px)",
            transition: "all 0.75s cubic-bezier(.4,0,.2,1) 0.2s",
          }}>
            {subtitle}
          </p>
        )}
      </div>

      {/* Bottom gradient bar */}
      <div style={{
        height: 2,
        background: `linear-gradient(90deg, ${BRAND.gold}, rgba(201,169,110,0.3), transparent)`,
      }} />
    </section>
  );
}
